<template>

  <div>
    <v-layout
      row
      wrap>
      <v-flex
        xs6
        sm6
        md4
      >
        <v-text-field
          v-model="search"
          prepend-icon="search"
          class="pl-2 pr-2"
          label="Search"
          placeholder="search by Quo.Ref/Name"
          clearable
          single-line
          hide-details/>
      </v-flex>
      <v-flex
        xs6
        sm6
        md4
      >
        <v-select
          v-model="searchBy.salesUsername"
          :items="userLogins"
          :item-text="usernameItemText"
          class="pl-2 pr-2"
          item-value="username"
          menu-props="auto"
          input-value="-ALL-"
          placeholder="Select..."
        >
          <template v-slot:label>
            Sales <v-icon style="vertical-align: middle">search</v-icon>
          </template>
        </v-select>
      </v-flex>
      <v-flex
        xs6
        sm6
        md4
      >
        <v-select
          v-model="searchBy.status"
          :items="['','OPEN','WIN','LOSE']"
          class="pl-2 pr-2"
          menu-props="auto"
          input-value="-ALL-"
          placeholder="Select..."
        >
          <template v-slot:label>
            Status <v-icon style="vertical-align: middle">search</v-icon>
          </template>
        </v-select>
      </v-flex>
    </v-layout>
    <v-flex
      md12
    >
      <v-btn
        color="general"
        dark
        class="mb-2 ml-1 mr-1"
        @click="$refs.downloadExcel.generate()"
      >
        <download-excel
          ref="downloadExcel"
          :fetch="fetchData"
          :fields="excelFields"
          :before-generate="showProgressBar"
          :before-finish="hideProgressBar"
          class="btn btn-default"
          worksheet="worksheet"
          name="Quotation-ALL.xls">
          <v-icon>mdi-file-excel</v-icon>&nbsp;
        </download-excel>Export All
      </v-btn>
      <v-dialog
        v-model="dialogDelete"
        max-width="400px">
        <v-card>
          <v-card-title class="headline">System Message Confirmation</v-card-title>
          <v-card-text>
            Are you sure want to remove this data? <br>
            "{{ selectedItemRecord.refNo }}"
          </v-card-text>
          <v-card-actions>
            <v-spacer/>

            <v-btn
              color="red darken-1"
              text
              flat
              @click="dialogDelete = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="green darken-1"
              text
              flat
              @click="deleteItem(selectedItemRecord)"
            >
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-progress-linear
        v-show="loadingBar"
        :indeterminate="true"/>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="DataList"
        :rows-per-page-items="rowsAmount"
        :pagination.sync="pagination"
        :total-items="totalRows"
        dense
        loading-text="Loading... Please wait"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <tr
            class="expandable"
            @click="props.expanded = !props.expanded">
            <td style="padding:5px">
              <v-icon
                medium
                class="mr-2"
                @click.stop="downloadQuoPdf(props.item)">mdi-file-pdf
              </v-icon>
              <v-icon
                medium
                class="mr-2"
                @click.stop="editItem(props.item, true)">mdi-content-duplicate
              </v-icon>
              <v-icon
                medium
                class="mr-2"
                @click.stop="dialogDeleteShow(props.item)">delete
              </v-icon>
            </td>
            <td><a
              href="#"
              @click.stop="editItem(props.item, false)">{{ props.item.refNo }}</a></td>
            <td>{{ props.item.name }}</td>
            <td><a
              href="#"
              @click.stop="dialogUpdateShow(props.item)">{{ props.item.status }}</a></td>
            <td>{{ props.item.quotationDate }}</td>
            <td>{{ props.item.paymentTermDesc }}</td>
            <td>{{ props.item.termDays }}</td>
            <td>{{ props.item.salesUsername }}</td>
            <td>{{ props.item.customer.company.name }}</td>
            <td class="price-format">{{ toPriceFormat(props.item.totalPrice) }}</td>
            <td>{{ showDiscountText(props.item) }}</td>
            <td class="price-format">{{ props.item.totalPriceAfterDisc == 0 ? '' :
            toPriceFormat(props.item.totalPriceAfterDisc) }}
            </td>
            <td>{{ props.item.shodan ? props.item.shodan.name : '' }}</td>
            <td>{{ props.item.createdBy }}</td>
            <td>{{ props.item.lastUpdateBy }}</td>
            <td>{{ toStringDate(props.item.lastUpdateDate) }}</td>
          </tr>
        </template>
        <template v-slot:expand="props">
          <v-flex mx-3>
            <v-card>
              <v-card-text align="left"><span class="expand-item">Note:</span> {{ props.item.note }}</v-card-text>
            </v-card>
          </v-flex>
          <v-spacer/>
          <v-flex mx-3>
            <v-data-table
              id="quoItemDetails"
              :items="props.item.itemDetails"
              :headers="subHeadersExpand"
              class="elevation-1"
              hide-actions
            >
              <template v-slot:items="props">
                <tr>
                  <td>{{ props.item.brand }}</td>
                  <td class="">{{ props.item.category }}</td>
                  <td class="">{{ props.item.materialNo }}</td>
                  <td class="">{{ props.item.materialDesc }}</td>
                  <td class="">{{ props.item.stockType }}</td>
                  <td class="">{{ props.item.qty }}</td>
                  <td class="price-format">{{ toPriceFormat(props.item.price.sellingPrice) }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </template>
      </v-data-table>

      <v-dialog
        v-model="dialogUpdateQuo"
        max-width="300px">
        <v-form
          id="form-vue"
          ref="form"
          v-model="valid"
          :lazy-validation="lazy"
        >
          <v-card>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex
                    xs12
                    sm12
                    md12
                  >
                    <v-select
                      v-model="quotationStatus"
                      :items="['OPEN', 'LOSE']"
                      :rules="[rules.required]"
                      menu-props="auto"
                      label="Status"
                      required
                      class="blue-input"/>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn
                color="red darken-1"
                flat
                @click="dialogUpdateQuo = false">Cancel
              </v-btn>
              <v-btn
                :disabled="!valid"
                color="green darken-1"
                flat
                @click="updateQuoStatus(selectedItemRecord)"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <v-snackbar
        v-model="snack"
        :timeout="5000"
        :color="snackColor">
        {{ snackText }}
        <v-btn
          flat
          @click="snack = false">Close
        </v-btn>
      </v-snackbar>
    </v-flex>
  </div>

</template>

<script>
  import displayFormatterMixins from '../../../mixins/displayFormatterMixins'
  import _ from 'lodash'
  import axios from 'axios'

  export default {
    name: 'QuoList',
    mixins: [displayFormatterMixins],
    props: {
      // eslint-disable-next-line vue/require-default-prop
      currencyList: Array,
      // eslint-disable-next-line vue/require-default-prop
      quoParams: Object
    },
    data: () => ({
      snack: false,
      valid: false,
      lazy: false,
      snackColor: '',
      snackText: '',
      loadingBar: false,
      rules: {
        required: value => !!value || 'Required.',
        max50chars: value => !value || value.length <= 50 || 'Max 50 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return !value || pattern.test(value) || 'Invalid e-mail.'
        },
        number: value => !isNaN(value) || 'Must be numeric'
      },
      expand: true,
      pagination: { sortBy: 'lastUpdateDate', descending: true },
      DataList: [],
      userLogins: [],
      totalRows: 0,
      rowsAmount: [5, 10, 25, 50],
      dialogUpdateQuo: false,
      dialogDelete: false,
      selectedItemRecord: {},
      loading: true,
      search: '',
      searchBy: {
        salesUsername: '',
        status: ''
      },
      headers: [
        { text: '--Actions--', value: 'actions', sortable: false },
        { text: 'Quo.Ref.', value: 'refNo' },
        { text: 'Name/Title', value: 'name' },
        { text: 'Status', value: 'status' },
        { text: 'Quo. Date', value: 'quotationDate' },
        { text: 'Payment Term', value: 'paymentTermDesc' },
        { text: 'Term Days', value: 'termDays' },
        { text: 'Sales', value: 'salesUsername' },
        { text: 'Company', value: 'customer.company.name' },
        { text: 'Price', value: 'totalPrice' },
        { text: 'Discount', value: 'discount' },
        { text: 'Price After Disc', value: 'totalPriceAfterDisc' },
        { text: 'Shodan', value: 'shodan.name' },
        { text: 'Created By', value: 'createdBy' },
        { text: 'Update By', value: 'lastUpdateBy' },
        { text: 'Update Date Time', value: 'lastUpdateDate' }
      ],
      subHeadersExpand: [
        { text: 'Brand', value: 'brand', sortable: false },
        { text: 'Category', value: 'category', sortable: false },
        { text: 'Material', value: 'materialNo', sortable: false },
        { text: 'Material Desc', value: 'materialDesc', sortable: false },
        { text: 'Stock Type', value: 'stockType', sortable: false },
        { text: 'Qty', value: 'qty', sortable: false },
        { text: 'Selling Price', value: 'price.sellingPrice', sortable: false }
      ],
      quotationStatus: '',
      excelFields: {
        'Quo Ref': 'refNo',
        'Name': 'name',
        'Status': 'status',
        'Quo. Date': 'quotationDate',
        'Payment Term': 'paymentTerm',
        'Term Days': 'termDays',
        'Sales': 'salesUsername',
        'Company': 'customer.company.name',
        'Price': 'totalPrice',
        'Discount': 'discount',
        'Price After Disc': 'totalPriceAfterDisc',
        'Shodan': 'shodan.name',
        'Created By': 'createdBy',
        'Update By': 'lastUpdateBy',
        'Update Date Time': {
          callback: (value) => {
            return new Date(value.lastUpdateDate).toLocaleDateString('en-GB')
          }
        }
      }
    }),
    computed: {},

    watch: {
      pagination: {
        async handler () {
          this.getQuotationList()
        },
        deep: true
      },
      search () {
        this.debouncedGetQuotationList()
      },
      searchBy: {
        async handler () {
          this.debouncedGetQuotationList()
        },
        deep: true
      }
    },
    // called when page is created before dom
    created () {
      this.debouncedGetQuotationList = _.debounce(this.getQuotationList, 500)
      this.getUserLogins()
    },
    mounted () {
    },
    methods: {
      showDiscountText (item) {
        if (item.discount) {
            if (item.discType === 'LUMP_SUM') {
              return this.toPriceFormat(item.discount)
            } else { // handle old data
              return item.discount + '%'
            }
        } else {
          return ''
        }
      },
      usernameItemText (item) {
        if (item.employee) { // bug workaround
          return item.username + ' (' + item.employee.firstName + ')'
        } else {
          return item.username
        }
      },
      // changeSort (column) {
      //   if (this.pagination.sortBy === column) {
      //     this.pagination.descending = !this.pagination.descending
      //   } else {
      //     this.pagination.sortBy = column
      //     this.pagination.descending = false
      //   }
      // },
      async downloadQuoPdf (item) { // can be centralized to VUEX action.js
        try {
          let respEmp = await this.$http.get(`/api/employee/${item.salesUsername}`)
          console.debug(respEmp.data)
          console.debug(item.itemDetails)
          let payload = {
            contacts: {
              companyName: item.customer.company.name,
              companyAddress: item.customer.company.address.street,
              up: item.customer.name,
              phone: item.customer.phone,
              mobile: item.customer.mobilePhone,
              email: item.customer.email
            },
            quotation: {
              id: item.refNo,
              date: item.quotationDate,
              salesName: respEmp.data.firstName,
              phone: respEmp.data.phoneNo,
              payment: item.paymentTermDesc,
              term: item.termDays,
              currency: 'IDR' // not used for now
            },
            name: item.title,
            discount: item.discount,
            discType: item.discType ? item.discType : 'PERCENTAGE',
            vat: item.isVat ? 11 : null,
            priceTotal: item.totalPrice,
            priceDiscount: item.totalPriceDisc,
            priceVat: item.isVat ? item.totalPriceVAT : null, // Math.round(item.totalPriceAfterDisc * 0.11) : null,
            priceGrandTotal: item.grandTotalPrice,
            comment: '',
            notes: item.footerNote,
            itemDetails: item.itemDetails // from "items" to "itemDetails"
          }
          console.debug(JSON.stringify(payload))
          let response = await axios({
            url: '/carbone/report_quotation',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': '*/*'
            },
            responseType: 'arraybuffer', // important,
            data: payload
          })
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', item.name + '.pdf') // or any other extension
          document.body.appendChild(link)
          link.click()
        } catch (error) {
          console.log(error)
          this.cancelInline()
        }
      },
      async getQuotationList () {
        try {
          this.loading = true
          const { sortBy, descending, page, rowsPerPage } = this.pagination
          let q = this.search == null ? '' : this.search

          let pageNoXHR = page - 1
          let response = await this.$http.get(`/api/quo?isb=true&ps=${rowsPerPage}&pn=${pageNoXHR}&so=${sortBy || 'lastUpdateDate'}&dc=${descending || false}&q=${q}&qsu=${this.searchBy.salesUsername}&qst=${this.searchBy.status}`)

          this.loading = false
          this.DataList = response.data.content
          this.totalRows = response.data.totalElements
        } catch (error) {
          console.log(error)
        }
      },
      async updateQuoStatus (rec) {
        let endpoint = `api/quo/${rec.id}`
        let method = 'patch'
        let tableItem = { status: this.quotationStatus }
        rec.status = this.quotationStatus
        try {
          await this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
          this.saveInline()
        } catch (error) {
          console.log(error)
          this.cancelInline()
        }
        this.dialogUpdateQuo = false
      },

      async editItem (item, isCopy) { // go to revision
        let editedItem = Object.assign({}, item)
        if (isCopy) {
          editedItem.id = null
          editedItem.status = 'OPEN'
          editedItem.shodan = {}
        }
        this.$store.commit('quo/setEditQuoRecord', editedItem)
        this.$emit('eventQuoList', 1) // change tab in parent
      },
      dialogDeleteShow (data) {
        this.dialogDelete = true
        this.selectedItemRecord = data
      },
      dialogUpdateShow (data) {
        this.dialogUpdateQuo = true
        this.selectedItemRecord = data
        this.quotationStatus = data.status
      },
      deleteItem (rec) {
        let endpoint = `api/quo/${rec.id}`
        let method = 'delete'
        let s = {}

        this.$store.dispatch('updateTableItem', { endpoint, s, method })
          .then((response) => {
            console.log(response)
            if (response.data.message === 'FAILED') {
              this.cancelInline(response.data.details)
            } else {
              this.deleteInline()
              this.DataList.splice(this.DataList.indexOf(rec), 1)
            }
          })
          .catch(error => {
            console.log(error)
            this.cancelInline()
          })
        this.dialogDelete = false
      },
      async fetchData () {
        const response = await this.$http.get(`/api/quo/all`)
        return response.data
      },
      async getUserLogins () {
        try {
          let response = await this.$http.get(`/api/userlogin/select`)
          this.userLogins = response.data
          this.userLogins.unshift({ id: null, username: '' })
        } catch (error) {
          console.log(error)
        }
      },
      showProgressBar () {
        this.loadingBar = true
      },
      hideProgressBar () {
        this.loadingBar = false
      },
      // toasts/snackbar messages for actions
      saveInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data saved/updated'
      },
      cancelInline (message) {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = message || 'Canceled'
      },
      deleteInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data removed'
      },
      reset () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data reset to default'
      },
      openInline () {
        this.snack = true
        this.snackColor = 'info'
        this.snackText = 'Dialog opened'
      },
      closeInline () {
        console.debug('Dialog closed')
      }
    }
  }
</script>

<style>
  #quoItemDetails thead tr {
    background-color: antiquewhite;
  }

  #quoItemDetails table.v-table thead tr th {
    font-size: 1.025em;
  }
</style>
